exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.note[data-v-2a828fef]{font-size:11px\n}\n", ""]);

// exports
